'use client';
import { createBrowserClient } from '@supabase/ssr';

let client: ReturnType<typeof createBrowserClient> | null = null;

/**
 * When the app runs inside a cross-site iframe (e.g. Rocket.new preview),
 * default `SameSite=Lax` auth cookies get treated as third-party and blocked.
 * Marking them `SameSite=None; Secure; Partitioned` (CHIPS) keeps the session
 * alive across navigations in that iframe. On plain HTTP (localhost dev) we
 * skip this because `Secure` cookies cannot be written over insecure origins.
 */
function iframeSafeCookieOptions(): { sameSite?: string; secure?: boolean; partitioned?: boolean } {
  if (typeof window === 'undefined') return {};
  if (window.location.protocol !== 'https:') return {};

  return {
    sameSite: 'none',
    secure: true,
    partitioned: true,
  };
}

export function createClient() {
  if (client) return client;
  client = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
      cookieOptions: iframeSafeCookieOptions(),
    }
  );
  return client;
}
